import { Building2, Cpu, Plane, UtensilsCrossed, type LucideIcon } from 'lucide-react';
import type { CrmLabel, FamilyKey } from '@/services/blueprints.service';

export const FAMILY_META: Record<FamilyKey, { icon: LucideIcon; tagline: string }> = {
  technology: { icon: Cpu, tagline: 'Clients, projects, retainers and support tickets.' },
  food: { icon: UtensilsCrossed, tagline: 'Guests, reservations, menu, orders and the kitchen floor.' },
  real_estate: { icon: Building2, tagline: 'Listings, viewings, leases, owners and tenants.' },
  travel: { icon: Plane, tagline: 'Packages, trip enquiries, bookings and travel requests.' },
};

export const familyIcon = (key?: string | null): LucideIcon => FAMILY_META[key as FamilyKey]?.icon ?? Cpu;

/** Label keys in editor order, with a hint of where each word shows. */
export const LABEL_ORDER: Array<{ key: string; where: string }> = [
  { key: 'leads', where: 'Leads group, inbox and lead pages' },
  { key: 'contacts', where: 'Contacts page, detail and import' },
  { key: 'deals', where: 'Deals board' },
  { key: 'appointments', where: 'Appointments group and calendar' },
  { key: 'services', where: 'Bookable services list' },
  { key: 'bookings', where: 'Bookings list' },
  { key: 'catalog', where: 'Catalog page' },
  { key: 'orders', where: 'Orders page' },
  { key: 'tickets', where: 'Support tickets' },
  { key: 'reservations', where: 'Tables & floor' },
  { key: 'staff', where: 'Staff & shifts' },
  { key: 'stock', where: 'Stock & inventory' },
  { key: 'projects', where: 'Projects & time' },
  { key: 'retainers', where: 'Retainers' },
  { key: 'properties', where: 'Properties & listings' },
  { key: 'viewings', where: 'Property viewings' },
  { key: 'leases', where: 'Leases' },
  { key: 'operations', where: 'Sidebar group for the industry pages' },
];

/** Which word renames a page's sidebar item (pages not listed keep their own name). */
export const PAGE_WORD: Record<string, string> = {
  contacts: 'contacts', deals: 'deals', appointment_services: 'services', bookings: 'bookings',
  catalog: 'catalog', orders: 'orders', tickets: 'tickets', reservations: 'reservations',
  staff: 'staff', stock: 'stock', projects: 'projects', retainers: 'retainers',
  properties: 'properties', viewings: 'viewings', leases: 'leases',
};

/** Sidebar group headers that follow a word. */
export const GROUP_WORD: Record<string, string> = { Leads: 'leads', Appointments: 'appointments', Operations: 'operations' };

export const wordOf = (labels: Record<string, CrmLabel>, defaults: Record<string, CrmLabel>, key: string, form: 'plural' | 'singular' = 'plural') =>
  labels[key]?.[form] || defaults[key]?.[form] || key;

export const DEPT_KINDS = [
  { value: 'sales', label: 'Sales & intake' },
  { value: 'ops', label: 'Operations' },
  { value: 'tech', label: 'Delivery / tech' },
  { value: 'support', label: 'Support' },
  { value: 'medical', label: 'Medical' },
  { value: 'legal', label: 'Legal' },
  { value: 'custom', label: 'Other' },
] as const;
